import { PostType } from '@/graphql/generated/types.generated';

export enum PostTypeNumber {
    STATUS = 1,
    MEDIA = 2,
    STORY = 3,
    LINK = 4,
    REEL = 5,
}

const PostTypeNumberMapper: Record<PostTypeNumber, PostType> = {
    [PostTypeNumber.STATUS]: PostType.Status,
    [PostTypeNumber.MEDIA]: PostType.Media,
    [PostTypeNumber.STORY]: PostType.Story,
    [PostTypeNumber.LINK]: PostType.Link,
    [PostTypeNumber.REEL]: PostType.Reel,
};

export default PostTypeNumberMapper;
